export const PATHS = [
  // 英語 (アメリカ)
  "PATH_82080980",
  "PATH_82089693",
  "PATH_82114485",
  "PATH_82137619",
  "PATH_85985687",
  "PATH_85985834",
  "PATH_85985989",
  "PATH_85986133",
  "PATH_84259913",
  "PATH_84263782",
  "PATH_84267012",
  "PATH_84292054",
  "PATH_84382711",
  "PATH_84382930",
  "PATH_84383100",
  "PATH_84383246",
  "PATH_84561982",
  "PATH_84588815",
  "PATH_84570494",
  "PATH_84601304",
  "PATH_84717015",
  "PATH_84716715",
  "PATH_84768651",
  "PATH_84771862",
  "PATH_84912294",
  "PATH_84958274",
  "PATH_84982521",
  "PATH_85152950",
  "PATH_84945210",
  "PATH_84993506",
  "PATH_84998740",
  "PATH_85002301",
  "PATH_85457996",
  "PATH_85458077",
  "PATH_85428849",
  "PATH_85338449",
  "PATH_85353251",
  "PATH_85357577",
  "PATH_85378339",
  "PATH_85434798",
  "PATH_186231880",
  "PATH_186233116",
  "PATH_186233228",
  "PATH_186233219",
  "PATH_186235995",
  "PATH_203107548",
  "PATH_186235985",
  "PATH_186237840",
  "PATH_186242920",
  "PATH_186242930",
  "PATH_186242907",
  "PATH_186242929",
  "PATH_186559572",
  "PATH_186559529",
  "PATH_186559566",
  "PATH_186559523",
  "PATH_186559553",
  "PATH_186559538",
  "PATH_186559550",
  "PATH_186559520",
  "PATH_186569484",
  "PATH_186569477",
  "PATH_186569482",
  "PATH_186569739",
  "PATH_186569740",
  "PATH_186569741",
  "PATH_186571714",
  "PATH_203242287",
  "PATH_186618470",
  "PATH_186618450",
  "PATH_186618449",
  "PATH_186774326",
  // フランス語
  "PATH_82080986",
  "PATH_82089695",
  "PATH_82114478",
  "PATH_82137615",
  "PATH_85985689",
  "PATH_85985842",
  "PATH_85985983",
  "PATH_85986140",
  "PATH_84259914",
  "PATH_84263781",
  "PATH_84267011",
  "PATH_84292045",
  "PATH_84382708",
  "PATH_84382927",
  "PATH_84383008",
  "PATH_84383249",
  "PATH_84561955",
  "PATH_84588814",
  "PATH_84570467",
  "PATH_84599464",
  "PATH_84717017",
  "PATH_84716722",
  "PATH_84768657",
  "PATH_84771661",
  "PATH_84912287",
  "PATH_84958261",
  "PATH_84982530",
  "PATH_85152955",
  "PATH_84945226",
  "PATH_84993523",
  "PATH_84998745",
  "PATH_85002311",
  "PATH_85457995",
  "PATH_85458092",
  "PATH_85428848",
  "PATH_85338453",
  "PATH_85353263",
  "PATH_85357578",
  "PATH_85378334",
  "PATH_85434796",
  "PATH_191018427",
  "PATH_191017696",
  "PATH_191017244",
  "PATH_191018384",
  "PATH_191018985",
  "PATH_199756478",
  "PATH_191019397",
  "PATH_191019337",
  "PATH_191018930",
  "PATH_191017350",
  "PATH_191019349",
  "PATH_191018692",
  "PATH_191017365",
  "PATH_191017091",
  "PATH_191018308",
  "PATH_191018469",
  "PATH_191019343",
  "PATH_191017228",
  "PATH_191017251",
  "PATH_191019010",
  "PATH_191017386",
  "PATH_191019128",
  "PATH_191019121",
  "PATH_191017770",
  "PATH_191018004",
  "PATH_191018222",
  "PATH_191018832",
  "PATH_199768892",
  "PATH_191017781",
  "PATH_191018059",
  "PATH_191019357",
  "PATH_191018151",
  // イタリア語
  "PATH_82080988",
  "PATH_82089696",
  "PATH_82114482",
  "PATH_82137621",
  "PATH_85985690",
  "PATH_85985838",
  "PATH_85985990",
  "PATH_85986141",
  "PATH_84259912",
  "PATH_84263778",
  "PATH_84267015",
  "PATH_84292046",
  "PATH_84382705",
  "PATH_84382933",
  "PATH_84383095",
  "PATH_84383254",
  "PATH_84562118",
  "PATH_84589134",
  "PATH_84570598",
  "PATH_84603882",
  "PATH_84719316",
  "PATH_84717651",
  "PATH_84768812",
  "PATH_84772525",
  "PATH_84913906",
  "PATH_84958270",
  "PATH_84982528",
  "PATH_85152956",
  "PATH_84945220",
  "PATH_84993521",
  "PATH_84998738",
  "PATH_85002314",
  "PATH_85458002",
  "PATH_85458091",
  "PATH_85429891",
  "PATH_85338709",
  "PATH_85353256",
  "PATH_85361763",
  "PATH_85379680",
  "PATH_85436953",
  "PATH_191035153",
  "PATH_191033816",
  "PATH_191033506",
  "PATH_191033147",
  "PATH_191034680",
  "PATH_199087924",
  "PATH_191033567",
  "PATH_191034880",
  "PATH_191034287",
  "PATH_191034097",
  "PATH_191033870",
  "PATH_191033875",
  "PATH_191035321",
  "PATH_191034651",
  "PATH_191034182",
  "PATH_191033475",
  "PATH_191035295",
  "PATH_191033972",
  "PATH_191033724",
  "PATH_191033621",
  "PATH_191034919",
  "PATH_191033850",
  "PATH_191034207",
  "PATH_191033360",
  "PATH_191034570",
  "PATH_191034458",
  "PATH_191035258",
  "PATH_199093314",
  "PATH_191035113",
  "PATH_191034710",
  "PATH_191035291",
  "PATH_191033709",
  // スペイン語 (スペイン)
  "PATH_82080983",
  "PATH_82089692",
  "PATH_82114486",
  "PATH_82137614",
  "PATH_85985688",
  "PATH_85985837",
  "PATH_85985991",
  "PATH_85986138",
  "PATH_84259916",
  "PATH_84263785",
  "PATH_84267013",
  "PATH_84292047",
  "PATH_84382710",
  "PATH_84382936",
  "PATH_84383098",
  "PATH_84383253",
  "PATH_84562251",
  "PATH_84589817",
  "PATH_84570648",
  "PATH_84605796",
  "PATH_84719315",
  "PATH_84719348",
  "PATH_84768811",
  "PATH_84772522",
  "PATH_84915439",
  "PATH_84959121",
  "PATH_84982524",
  "PATH_85152952",
  "PATH_84945221",
  "PATH_84993504",
  "PATH_84998746",
  "PATH_85002316",
  "PATH_85457999",
  "PATH_85458079",
  "PATH_85429897",
  "PATH_85338706",
  "PATH_85353253",
  "PATH_85361758",
  "PATH_85379684",
  "PATH_85437401",
  "PATH_191042396",
  "PATH_191042202",
  "PATH_191043285",
  "PATH_191042350",
  "PATH_191043366",
  "PATH_198068355",
  "PATH_191042612",
  "PATH_191043427",
  "PATH_191041410",
  "PATH_191042965",
  "PATH_191042758",
  "PATH_191043372",
  "PATH_191043362",
  "PATH_191043528",
  "PATH_191043083",
  "PATH_191041855",
  "PATH_191041199",
  "PATH_191042103",
  "PATH_191041991",
  "PATH_191041540",
  "PATH_191041967",
  "PATH_191042074",
  "PATH_191041477",
  "PATH_191043051",
  "PATH_191041750",
  "PATH_191041592",
  "PATH_191041593",
  "PATH_198079458",
  "PATH_191043141",
  "PATH_191043246",
  "PATH_191041929",
  "PATH_191043093",
  // ドイツ語
  "PATH_82080981",
  "PATH_82089690",
  "PATH_82114480",
  "PATH_82137616",
  "PATH_85985684",
  "PATH_85985836",
  "PATH_85985988",
  "PATH_85986142",
  "PATH_84259915",
  "PATH_84263779",
  "PATH_84267014",
  "PATH_84292052",
  "PATH_84382706",
  "PATH_84382932",
  "PATH_84383014",
  "PATH_84383247",
  "PATH_84561848",
  "PATH_84588637",
  "PATH_84570438",
  "PATH_84599370",
  "PATH_84717014",
  "PATH_84716724",
  "PATH_84768652",
  "PATH_84771663",
  "PATH_84912286",
  "PATH_84958269",
  "PATH_84982532",
  "PATH_85152958",
  "PATH_84945228",
  "PATH_84993518",
  "PATH_84998748",
  "PATH_85002298",
  "PATH_85458001",
  "PATH_85458080",
  "PATH_85428854",
  "PATH_85338458",
  "PATH_85353261",
  "PATH_85357579",
  "PATH_85378342",
  "PATH_85434797",
  "PATH_191026284",
  "PATH_191025533",
  "PATH_191025335",
  "PATH_191026695",
  "PATH_191026929",
  "PATH_199657405",
  "PATH_191026443",
  "PATH_191027205",
  "PATH_191026328",
  "PATH_191026069",
  "PATH_191026343",
  "PATH_191026882",
  "PATH_191025215",
  "PATH_191025610",
  "PATH_191025188",
  "PATH_191026073",
  "PATH_191026310",
  "PATH_191025390",
  "PATH_191025328",
  "PATH_191026262",
  "PATH_191025759",
  "PATH_191026074",
  "PATH_191025575",
  "PATH_191026160",
  "PATH_191026638",
  "PATH_191026873",
  "PATH_191025116",
  "PATH_199664506",
  "PATH_191026536",
  "PATH_191025345",
  "PATH_191026679",
  "PATH_191026032",
  // 中国語 (マンダリン)
  "PATH_123401144",
  "PATH_123400981",
  "PATH_123401278",
  "PATH_123400395",
  "PATH_123400509",
  "PATH_123401008",
  "PATH_123401132",
  "PATH_123401470",
  "PATH_123407990",
  "PATH_123408104",
  "PATH_123407951",
  "PATH_123407437",
  "PATH_123406552",
  "PATH_123406668",
  "PATH_123407641",
  "PATH_123407699",
  "PATH_123408174",
  "PATH_123407769",
  "PATH_123406775",
  "PATH_123407384",
  "PATH_123407223",
  "PATH_123408168",
  "PATH_123406988",
  "PATH_123407907",
  "PATH_123406648",
  "PATH_123407158",
  "PATH_123407402",
  "PATH_123407093",
  "PATH_123406734",
  "PATH_123407852",
  "PATH_123407059",
  "PATH_123408128",
  "PATH_220074752",
  "PATH_220074664",
  "PATH_220075222",
  "PATH_220075157",
  "PATH_220081675",
  "PATH_220081187",
  "PATH_220081825",
  "PATH_220081209",
  "PATH_220081297",
  "PATH_220082142",
  "PATH_220080422",
  "PATH_220081932",
  "PATH_220082983",
  "PATH_220081130",
  "PATH_220083021",
  "PATH_220080858",
  "PATH_220095600",
  "PATH_220092911",
  "PATH_220096619",
  "PATH_220095723",
  "PATH_220097133",
  "PATH_220093680",
  "PATH_220094996",
  "PATH_220096080",
  "PATH_220096900",
  "PATH_220093279",
  "PATH_220094916",
  "PATH_220095043",
  "PATH_220093091",
  "PATH_220093452",
  "PATH_220094854",
  "PATH_220092765",
  // 韓国語
  "PATH_141525331",
  "PATH_141525257",
  "PATH_141525296",
  "PATH_141524834",
  "PATH_141535663",
  "PATH_141535561",
  "PATH_141535392",
  "PATH_141535179",
  "PATH_141535762",
  "PATH_141535117",
  "PATH_141535389",
  "PATH_141535168",
  "PATH_141535181",
  "PATH_141535036",
  "PATH_141535187",
  "PATH_141535109",
  "PATH_141541550",
  "PATH_141542116",
  "PATH_141541743",
  "PATH_141541853",
  "PATH_141542040",
  "PATH_141541722",
  "PATH_141542264",
  "PATH_141542018",
  "PATH_141541760",
  "PATH_141541685",
  "PATH_141542092",
  "PATH_141542187",
  "PATH_141550769",
  "PATH_141551026",
  "PATH_141551056",
  "PATH_141550877",
  "PATH_141550778",
  "PATH_141550628",
  "PATH_141551050",
  "PATH_141550788",
  "PATH_141550402",
  "PATH_141550467",
  "PATH_141550668",
  "PATH_141551138",
  // アイルランド語
  "PATH_123435003",
  "PATH_123435055",
  "PATH_123435286",
  "PATH_123435359",
  "PATH_123438132",
  "PATH_123438238",
  "PATH_123438258",
  "PATH_123438260",
  "PATH_123438305",
  "PATH_123438330",
  "PATH_123438377",
  "PATH_123438426",
  "PATH_123438430",
  "PATH_123438498",
  "PATH_123438682",
  "PATH_123438734",
  "PATH_123439036",
  "PATH_123439038",
  "PATH_123439075",
  "PATH_123439082",
  "PATH_123439232",
  "PATH_123439236",
  "PATH_123439335",
  "PATH_123439439",
  "PATH_123443525",
  "PATH_123443728",
  "PATH_123443797",
  "PATH_123443815",
  "PATH_123443849",
  "PATH_123443885",
  "PATH_123443895",
  "PATH_123443896",
  "PATH_123443919",
  "PATH_123443949",
  "PATH_123444041",
  "PATH_123444190",
  "PATH_123444395",
  "PATH_123444487",
  "PATH_123444572",
  "PATH_123444587",
  // アラビア語
  "PATH_82080987",
  "PATH_82089691",
  "PATH_82114479",
  "PATH_82137618",
  "PATH_84259911",
  "PATH_84263780",
  "PATH_84267020",
  "PATH_84292049",
  "PATH_84382704",
  "PATH_84382928",
  "PATH_84383097",
  "PATH_84383250",
  "PATH_84562053",
  "PATH_84570533",
  "PATH_84588989",
  "PATH_84601827",
  "PATH_84716723",
  "PATH_84717013",
  "PATH_84768736",
  "PATH_84772110",
  "PATH_84912292",
  "PATH_84945209",
  "PATH_84958265",
  "PATH_84982518",
  "PATH_84993505",
  "PATH_84998751",
  "PATH_85002312",
  "PATH_85152944",
  "PATH_85338450",
  "PATH_85353246",
  "PATH_85358146",
  "PATH_85378343",
  "PATH_85428847",
  "PATH_85436951",
  "PATH_85458000",
  "PATH_85458083",
  "PATH_85985683",
  "PATH_85985835",
  "PATH_85985986",
  "PATH_85986134",
  // オランダ語
  "PATH_140514501",
  "PATH_140514510",
  "PATH_140514549",
  "PATH_140514599",
  "PATH_140514622",
  "PATH_140514640",
  "PATH_140514681",
  "PATH_140514691",
  "PATH_140514793",
  "PATH_140514919",
  "PATH_140514976",
  "PATH_140515125",
  "PATH_140515153",
  "PATH_140515157",
  "PATH_140515201",
  "PATH_140515291",
  "PATH_140515312",
  "PATH_140515411",
  "PATH_140515516",
  "PATH_140515526",
  "PATH_140515532",
  "PATH_140515777",
  "PATH_140515940",
  "PATH_140515996",
  "PATH_140516030",
  "PATH_140516064",
  "PATH_140516134",
  "PATH_140516482",
  "PATH_140516584",
  "PATH_140516726",
  "PATH_140516770",
  "PATH_140516773",
  "PATH_140516927",
  "PATH_140517041",
  "PATH_140517203",
  "PATH_140517207",
  "PATH_140517453",
  "PATH_140517465",
  "PATH_140517493",
  "PATH_140517619",
  // ギリシャ語
  "PATH_140576982",
  "PATH_140577090",
  "PATH_140577395",
  "PATH_140577518",
  "PATH_140577529",
  "PATH_140577561",
  "PATH_140577565",
  "PATH_140577566",
  "PATH_140577698",
  "PATH_140577712",
  "PATH_140577913",
  "PATH_140578056",
  "PATH_140578096",
  "PATH_140578098",
  "PATH_140578317",
  "PATH_140578359",
  "PATH_140578406",
  "PATH_140578521",
  "PATH_140578630",
  "PATH_140578646",
  "PATH_140578754",
  "PATH_140578810",
  "PATH_140578818",
  "PATH_140578844",
  "PATH_140578899",
  "PATH_140578956",
  "PATH_140579052",
  "PATH_140579056",
  "PATH_140579080",
  "PATH_140579322",
  "PATH_140579458",
  "PATH_140579717",
  "PATH_140579730",
  "PATH_140579757",
  "PATH_140579857",
  "PATH_140579861",
  "PATH_140579939",
  "PATH_140580121",
  "PATH_140580122",
  "PATH_140580287",
  // スウェーデン語
  "PATH_140531361",
  "PATH_140531519",
  "PATH_140531542",
  "PATH_140531594",
  "PATH_140531709",
  "PATH_140531906",
  "PATH_140531959",
  "PATH_140532083",
  "PATH_140532115",
  "PATH_140532125",
  "PATH_140532138",
  "PATH_140532202",
  "PATH_140532261",
  "PATH_140532326",
  "PATH_140532349",
  "PATH_140532353",
  "PATH_140532556",
  "PATH_140532864",
  "PATH_140533045",
  "PATH_140533064",
  "PATH_140533150",
  "PATH_140533186",
  "PATH_140533252",
  "PATH_140533269",
  "PATH_140533333",
  "PATH_140533416",
  "PATH_140533544",
  "PATH_140533610",
  "PATH_140533698",
  "PATH_140533741",
  "PATH_140533774",
  "PATH_140534009",
  "PATH_140534087",
  "PATH_140534089",
  "PATH_140534123",
  "PATH_140534190",
  "PATH_140534215",
  "PATH_140534553",
  "PATH_140534674",
  "PATH_140534695",
  // スペイン語 (ラテンアメリカ)
  "PATH_82080989",
  "PATH_82089697",
  "PATH_82114483",
  "PATH_82137612",
  "PATH_84259917",
  "PATH_84263783",
  "PATH_84267019",
  "PATH_84292050",
  "PATH_84382713",
  "PATH_84382931",
  "PATH_84383093",
  "PATH_84383245",
  "PATH_84562080",
  "PATH_84570560",
  "PATH_84589065",
  "PATH_84601830",
  "PATH_84716718",
  "PATH_84717012",
  "PATH_84768735",
  "PATH_84772108",
  "PATH_84912293",
  "PATH_84945223",
  "PATH_84958273",
  "PATH_84982520",
  "PATH_84993514",
  "PATH_84998750",
  "PATH_85002308",
  "PATH_85152961",
  "PATH_85338710",
  "PATH_85353250",
  "PATH_85358147",
  "PATH_85378337",
  "PATH_85428851",
  "PATH_85436952",
  "PATH_85458003",
  "PATH_85458076",
  "PATH_85985685",
  "PATH_85985840",
  "PATH_85985987",
  "PATH_85986137",
  "PATH_186247061",
  "PATH_186247074",
  "PATH_186247273",
  "PATH_186247279",
  "PATH_186247470",
  "PATH_186247480",
  "PATH_186247488",
  "PATH_186247903",
  "PATH_186247909",
  "PATH_186247914",
  "PATH_186248141",
  "PATH_186570536",
  "PATH_186570537",
  "PATH_186570547",
  "PATH_186570549",
  "PATH_186570550",
  "PATH_186570552",
  "PATH_186570567",
  "PATH_186570585",
  "PATH_186571883",
  "PATH_186571887",
  "PATH_186573219",
  "PATH_186573224",
  "PATH_186573912",
  "PATH_186573923",
  "PATH_186573926",
  "PATH_186621387",
  "PATH_186621388",
  "PATH_186621390",
  "PATH_186621393",
  "PATH_203107551",
  "PATH_203242284",
  // トルコ語
  "PATH_168820639",
  "PATH_168820693",
  "PATH_168820698",
  "PATH_168821139",
  "PATH_168821372",
  "PATH_168821948",
  "PATH_168822559",
  "PATH_168822699",
  "PATH_168837736",
  "PATH_168837977",
  "PATH_168837996",
  "PATH_168838285",
  "PATH_168838347",
  "PATH_168838357",
  "PATH_168838495",
  "PATH_168838581",
  "PATH_168838783",
  "PATH_168838864",
  "PATH_168838976",
  "PATH_168839093",
  "PATH_168839153",
  "PATH_168839243",
  "PATH_168839293",
  "PATH_168839461",
  "PATH_168839493",
  "PATH_168839511",
  "PATH_168839515",
  "PATH_168839628",
  "PATH_168839757",
  "PATH_168840144",
  "PATH_168840260",
  "PATH_168840366",
  "PATH_168840463",
  "PATH_168840940",
  "PATH_168841072",
  "PATH_168841306",
  "PATH_168841349",
  "PATH_168841595",
  "PATH_168841664",
  "PATH_168841884",
  // ヒンディー語
  "PATH_140985832",
  "PATH_140985879",
  "PATH_140985906",
  "PATH_140986035",
  "PATH_140986667",
  "PATH_140986773",
  "PATH_140986815",
  "PATH_140986833",
  "PATH_140986836",
  "PATH_140986895",
  "PATH_140986915",
  "PATH_140986951",
  "PATH_140987103",
  "PATH_140987115",
  "PATH_140987122",
  "PATH_140987239",
  "PATH_140987243",
  "PATH_140987338",
  "PATH_140987415",
  "PATH_140987434",
  "PATH_140987546",
  "PATH_140987704",
  "PATH_140987724",
  "PATH_140987740",
  "PATH_140987901",
  "PATH_140987946",
  "PATH_140988158",
  "PATH_140988299",
  "PATH_140988333",
  "PATH_140988379",
  "PATH_140988444",
  "PATH_140988515",
  "PATH_140988594",
  "PATH_140988686",
  "PATH_140988736",
  "PATH_140988859",
  "PATH_140988932",
  "PATH_140988981",
  "PATH_140989056",
  "PATH_140989180",
  // フィリピン語 (タガログ語)
  "PATH_167225137",
  "PATH_167225234",
  "PATH_167225236",
  "PATH_167225252",
  "PATH_167225255",
  "PATH_167225384",
  "PATH_167225406",
  "PATH_167225668",
  "PATH_167225696",
  "PATH_167225854",
  "PATH_167226088",
  "PATH_167226113",
  "PATH_167226338",
  "PATH_167226430",
  "PATH_167226446",
  "PATH_167226683",
  "PATH_167226933",
  "PATH_167227083",
  "PATH_167227091",
  "PATH_167227114",
  "PATH_167227134",
  "PATH_167227167",
  "PATH_167227516",
  "PATH_167227621",
  "PATH_167227661",
  "PATH_167227748",
  "PATH_167227780",
  "PATH_167227898",
  "PATH_167228024",
  "PATH_167228053",
  "PATH_167228124",
  "PATH_167228282",
  "PATH_167228317",
  "PATH_167228419",
  "PATH_167228502",
  "PATH_167228567",
  "PATH_168506592",
  "PATH_168506671",
  "PATH_168506695",
  "PATH_168506751",
  // ベトナム語
  "PATH_168805212",
  "PATH_168805275",
  "PATH_168805396",
  "PATH_168805474",
  "PATH_168805826",
  "PATH_168805908",
  "PATH_168805952",
  "PATH_168806070",
  "PATH_168806198",
  "PATH_168806327",
  "PATH_168806369",
  "PATH_168806417",
  "PATH_168806465",
  "PATH_168806582",
  "PATH_168806591",
  "PATH_168806692",
  "PATH_168806773",
  "PATH_168806838",
  "PATH_168806858",
  "PATH_168806862",
  "PATH_168806937",
  "PATH_168806964",
  "PATH_168806972",
  "PATH_168807112",
  "PATH_168807204",
  "PATH_168807211",
  "PATH_168807268",
  "PATH_168807331",
  "PATH_168807389",
  "PATH_168807558",
  "PATH_168807634",
  "PATH_168807736",
  "PATH_168807757",
  "PATH_168807758",
  "PATH_168807897",
  "PATH_168808068",
  "PATH_168808214",
  "PATH_168808219",
  "PATH_168808252",
  "PATH_168808314",
  // ヘブライ語
  "PATH_139852319",
  "PATH_139852682",
  "PATH_139852689",
  "PATH_139852753",
  "PATH_139855539",
  "PATH_139857886",
  "PATH_139859178",
  "PATH_139859184",
  "PATH_139861556",
  "PATH_139861557",
  "PATH_139863042",
  "PATH_139863046",
  "PATH_139863759",
  "PATH_139863760",
  "PATH_139863761",
  "PATH_139863762",
  "PATH_139864473",
  "PATH_139864474",
  "PATH_139864766",
  "PATH_139864767",
  "PATH_139865129",
  "PATH_139865130",
  "PATH_139865131",
  "PATH_139866069",
  "PATH_139866071",
  "PATH_139866073",
  "PATH_139866075",
  "PATH_139866291",
  "PATH_139867590",
  "PATH_139867595",
  "PATH_139867596",
  "PATH_139867598",
  "PATH_139867599",
  "PATH_139867921",
  "PATH_139867922",
  "PATH_139867923",
  "PATH_139870355",
  "PATH_139870356",
  "PATH_139870357",
  "PATH_139870358",
  // ペルシア語 (ファルシ語)
  "PATH_140719211",
  "PATH_140719303",
  "PATH_140719347",
  "PATH_140719506",
  "PATH_140719650",
  "PATH_140719713",
  "PATH_140719770",
  "PATH_140719833",
  "PATH_140719981",
  "PATH_140719990",
  "PATH_140720083",
  "PATH_140720149",
  "PATH_140720204",
  "PATH_140720223",
  "PATH_140720238",
  "PATH_140720298",
  "PATH_140720323",
  "PATH_140720345",
  "PATH_140720523",
  "PATH_140720731",
  "PATH_140720739",
  "PATH_140720812",
  "PATH_140720943",
  "PATH_140720989",
  "PATH_140721020",
  "PATH_140721191",
  "PATH_140721289",
  "PATH_140721340",
  "PATH_140721419",
  "PATH_140721527",
  "PATH_140721567",
  "PATH_140721604",
  "PATH_140721645",
  "PATH_140721955",
  "PATH_140722062",
  "PATH_140722117",
  "PATH_140722142",
  "PATH_140722201",
  "PATH_140722236",
  "PATH_140722361",
  // ポーランド語
  "PATH_140403192",
  "PATH_140403283",
  "PATH_140403300",
  "PATH_140403329",
  "PATH_140403354",
  "PATH_140403428",
  "PATH_140403642",
  "PATH_140403714",
  "PATH_140404033",
  "PATH_140404062",
  "PATH_140404069",
  "PATH_140404190",
  "PATH_140404193",
  "PATH_140404552",
  "PATH_140404710",
  "PATH_140404879",
  "PATH_140404884",
  "PATH_140404973",
  "PATH_140404982",
  "PATH_140405167",
  "PATH_140405278",
  "PATH_140405397",
  "PATH_140405446",
  "PATH_140405476",
  "PATH_140405516",
  "PATH_140405614",
  "PATH_140405638",
  "PATH_140405760",
  "PATH_140405840",
  "PATH_140406099",
  "PATH_140406143",
  "PATH_140406162",
  "PATH_140406203",
  "PATH_140406272",
  "PATH_140406308",
  "PATH_140406330",
  "PATH_140406341",
  "PATH_140406346",
  "PATH_140406354",
  "PATH_140406508",
  // ポルトガル語 (ブラジル)
  "PATH_82080995",
  "PATH_82089698",
  "PATH_82114481",
  "PATH_82137613",
  "PATH_84259918",
  "PATH_84263784",
  "PATH_84267016",
  "PATH_84292051",
  "PATH_84382709",
  "PATH_84382935",
  "PATH_84383096",
  "PATH_84383248",
  "PATH_84562154",
  "PATH_84570622",
  "PATH_84589602",
  "PATH_84603974",
  "PATH_84719197",
  "PATH_84719318",
  "PATH_84768808",
  "PATH_84772521",
  "PATH_84913908",
  "PATH_84945227",
  "PATH_84959119",
  "PATH_84982523",
  "PATH_84993507",
  "PATH_84998754",
  "PATH_85002310",
  "PATH_85152962",
  "PATH_85338707",
  "PATH_85353247",
  "PATH_85361757",
  "PATH_85379679",
  "PATH_85429896",
  "PATH_85437220",
  "PATH_85458004",
  "PATH_85458090",
  "PATH_85985692",
  "PATH_85985833",
  "PATH_85985984",
  "PATH_85986139",
  // ロシア語
  "PATH_82080998",
  "PATH_82089689",
  "PATH_82114484",
  "PATH_82137620",
  "PATH_84259919",
  "PATH_84263777",
  "PATH_84267017",
  "PATH_84292048",
  "PATH_84382712",
  "PATH_84382934",
  "PATH_84383099",
  "PATH_84383251",
  "PATH_84562008",
  "PATH_84577723",
  "PATH_84588887",
  "PATH_84601826",
  "PATH_84716725",
  "PATH_84717016",
  "PATH_84768653",
  "PATH_84771860",
  "PATH_84912290",
  "PATH_84945225",
  "PATH_84958271",
  "PATH_84982522",
  "PATH_84993516",
  "PATH_84998741",
  "PATH_85002315",
  "PATH_85152949",
  "PATH_85338455",
  "PATH_85353257",
  "PATH_85358142",
  "PATH_85378344",
  "PATH_85428843",
  "PATH_85434860",
  "PATH_85457997",
  "PATH_85458075",
  "PATH_85985691",
  "PATH_85985839",
  "PATH_85985992",
  "PATH_85986136",
  "PATH_220074987",
  "PATH_220075185",
  "PATH_220075231",
  "PATH_220075680",
  "PATH_220080111",
  "PATH_220080492",
  "PATH_220080555",
  "PATH_220080674",
  "PATH_220080817",
  "PATH_220081941",
  "PATH_220082061",
  "PATH_220082087",
  "PATH_220082150",
  "PATH_220082711",
  "PATH_220083088",
  "PATH_220083382",
  "PATH_220092690",
  "PATH_220092825",
  "PATH_220092861",
  "PATH_220093935",
  "PATH_220093938",
  "PATH_220094002",
  "PATH_220094260",
  "PATH_220094409",
  "PATH_220094416",
  "PATH_220095151",
  "PATH_220095261",
  "PATH_220095601",
  "PATH_220095766",
  "PATH_220096005",
  "PATH_220096397",
  "PATH_220097063",
  "PATH_222297293",
  "PATH_222336010",
  "PATH_222355164",
  "PATH_222368330",
  "PATH_222741239",
  "PATH_222899642",
  "PATH_222903256",
  "PATH_225177672",
  // 英語 (イギリス)
  "PATH_82080997",
  "PATH_82089699",
  "PATH_82114477",
  "PATH_82137611",
  "PATH_84259910",
  "PATH_84263776",
  "PATH_84267018",
  "PATH_84292053",
  "PATH_84382707",
  "PATH_84382929",
  "PATH_84383094",
  "PATH_84383252",
  "PATH_84562279",
  "PATH_84571203",
  "PATH_84589963",
  "PATH_84605794",
  "PATH_84719317",
  "PATH_84721291",
  "PATH_84768807",
  "PATH_84772654",
  "PATH_84915438",
  "PATH_84945219",
  "PATH_84962784",
  "PATH_84982533",
  "PATH_84993519",
  "PATH_84998743",
  "PATH_85002309",
  "PATH_85152945",
  "PATH_85338708",
  "PATH_85353391",
  "PATH_85361759",
  "PATH_85379963",
  "PATH_85429895",
  "PATH_85438214",
  "PATH_85457998",
  "PATH_85458086",
  "PATH_85985686",
  "PATH_85985841",
  "PATH_85985985",
  "PATH_85986135",
  "PATH_220074847",
  "PATH_220074941",
  "PATH_220075141",
  "PATH_220075196",
  "PATH_220080340",
  "PATH_220080433",
  "PATH_220080623",
  "PATH_220080665",
  "PATH_220080736",
  "PATH_220080742",
  "PATH_220081789",
  "PATH_220082393",
  "PATH_220082427",
  "PATH_220082609",
  "PATH_220083196",
  "PATH_220083291",
  "PATH_220092807",
  "PATH_220093180",
  "PATH_220094049",
  "PATH_220094112",
  "PATH_220094168",
  "PATH_220094543",
  "PATH_220095334",
  "PATH_220095427",
  "PATH_220095650",
  "PATH_220095762",
  "PATH_220096033",
  "PATH_220096148",
  "PATH_220096197",
  "PATH_220096231",
  "PATH_220096677",
  "PATH_220096743",
  // 日本語
  "PATH_136182514",
  "PATH_137805718",
  "PATH_137919762",
  "PATH_137919763",
  "PATH_137919764",
  "PATH_137919765",
  "PATH_137919794",
  "PATH_137919795",
  "PATH_137919796",
  "PATH_137919797",
  "PATH_137919826",
  "PATH_137919827",
  "PATH_137919828",
  "PATH_137919829",
  "PATH_137919858",
  "PATH_137919859",
  "PATH_137919860",
  "PATH_138741257",
  "PATH_138741263",
];



// WEBPACK FOOTER //
// ./src/mixin/exclusions.js